import { Stepper, Step, StepLabel, StepConnector } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CheckOutlined } from "@mui/icons-material";

// Custom Connector (line between steps)
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  "&.MuiStepConnector-root": {
    top: "50%",
    left: "calc(-50% - 16px)",
    right: "calc(50% + 21px)",
  },
  "& .MuiStepConnector-line": {
    borderColor: theme.palette.grey[200],
    borderTopWidth: 1,
    borderRadius: 1,
    width: "100%",
  },
}));

// Custom Step Icon
const CustomStepIcon = styled("div")<{ completed?: boolean; active?: boolean }>(
  ({ theme, completed }) => ({
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: completed ? "#005140" : theme.palette.grey[500],
    color: theme.palette.grey[200],
  }),
);

// Custom Stepper Container with spacing between steps
const CustomStepperContainer = styled(Stepper)({
  display: "flex",
  justifyContent: "space-around",
  gap: "40px",
});

interface StepperProps {
  steps: number[];
  activeStep: number;
  onStepClick?: (stepIndex: number) => void;
}

const CustomStepper: React.FC<StepperProps> = ({
  steps,
  activeStep,
  onStepClick,
}) => {
  return (
    <CustomStepperContainer
      alternativeLabel
      activeStep={activeStep}
      connector={<CustomConnector />}
    >
      {steps.map((_, index) => (
        <Step key={index}>
          <StepLabel
            sx={{
              fontSize: "12px",
              cursor: onStepClick ? "pointer" : "default",
            }}
            onClick={() => onStepClick?.(index)}
            StepIconComponent={() => (
              <CustomStepIcon
                active={activeStep === index}
                completed={activeStep > 0 && index === 0}
                style={{
                  cursor: onStepClick ? "pointer" : "default",
                }}
                onClick={() => onStepClick?.(index)}
              >
                {activeStep > 0 && index === 0 ? (
                  <CheckOutlined sx={{ width: "14px" }} />
                ) : (
                  index + 1
                )}
              </CustomStepIcon>
            )}
          />
        </Step>
      ))}
    </CustomStepperContainer>
  );
};

export default CustomStepper;
